export const systemEn = {
  // LegalPage
  'system.legal.fallbackTitle': 'Document',
  'system.legal.fallbackBody': 'Not found.',
  'system.legal.lastUpdated': 'Last updated {date}',
  'system.legal.siteAddendumHeading': '{world} — Additional Terms',

  // Admin → LegalEditorPage
  'admin.legal.seoTitle': 'Legal Content',
  'admin.legal.heading': 'Legal Content',
  'admin.legal.intro': 'Edit the optional site-specific block shown below the shared global text on each legal page.',
  'admin.legal.docLabel': 'Document',
  'admin.legal.localeLabel': 'Locale',
  'admin.legal.titleLabel': 'Heading (optional)',
  'admin.legal.titlePlaceholder': '{world} — Additional Terms',
  'admin.legal.updatedLabel': 'Updated date (optional)',
  'admin.legal.bodyLabel': 'Content (Markdown)',
  'admin.legal.bodyPlaceholder': '## A site-specific clause\n\nText that applies only to this site…',
  'admin.legal.preview': 'Preview',
  'admin.legal.previewEmpty': 'Nothing to preview yet.',
  'admin.legal.save': 'Save',
  'admin.legal.saving': 'Saving…',
  'admin.legal.delete': 'Delete this block',
  'admin.legal.saved': 'Saved.',
  'admin.legal.forbidden': 'Admin access required.',
  'admin.legal.error': 'Could not save. Try again.',

  // NotFoundPage
  'system.notFound.seoTitle': 'Lost in the Veil',
  'system.notFound.heading': "You have wandered beyond the map's edge",
  'system.notFound.body': 'The path you sought has been swallowed by the eternal twilight.',
  'system.notFound.returnCta': 'Return to The Veil',

  // RouteErrorBoundary
  'system.error.unknownDisturbance': 'An unknown disturbance shook the veil.',
  'system.error.seoTitle': 'A Disturbance in the Veil',
  'system.error.heading': 'The ritual faltered',
  'system.error.body':
    'Something unseen disrupted this page. The veil is thin here — try again, or return to safer ground.',
  'system.error.tryAgain': 'Try Again',
  'system.error.returnCta': 'Return to The Veil',

  // ErrorState (generic inline error card)
  'system.error.disturbanceTitle': 'A Disturbance in the Veil',

  // DataState (DataError / DataEmpty defaults)
  'system.data.veilClouded': 'The Veil Is Clouded',
  'system.data.scryingDark': 'The scrying glass has gone dark — this lore could not be summoned.',
  'system.data.archiveSilent': 'The Archive Is Silent',
  'system.data.stirsAsTwilightDeepens': 'Nothing stirs here yet. Return as the eternal twilight deepens.',

  'licenseGate.heading': "Coming soon — license restricted",
  'licenseGate.body': "This language edition isn't available yet for licensing reasons. It's on the way — check back soon.",
} as const
